const FrpApk = () => {
    return(
        <div className="apk-container">
            <div className="apk-wrapper">
                <div className="apk-content">
                    <h1>FRP BYPASS APK</h1>
                    <p>
                        Download and Bypass Frp on all Android Phone Starting from<br/>
                        Android 2.3.6 to Android 11 without a Computer and all apk<br/>
                        tools are free no cost.
                    </p>
                </div>
                <div className="title">
                    <h3>ALL GOOGLE ACCOUNT BYPASS TOOL</h3>
                </div>
                <div className="apk-links">
                    <a href="Apex Launcher(Ronnie Tech).apk" download='Apex Laucher(RonnieTech).apk'>
                            Apex Launcher
                    </a>
                    <a href="Nova Launcher(RonnieTech).apk" download='Apex Laucher(RonnieTech).apk'>
                            Nova Launcher
                    </a>
                    <a href="Android 4.0 4.0_GAM.apk" download='Android 4.0_GAM(RonnieTech).apk'>
                            Android 4.0 4.0_GAM
                    </a>
                    <a href="Android_5_GAM.apk" download='Android_5_GAM.apk'>
                            Android_5_GAM
                    </a>
                        <a href="Android_6_GAM.apk" download='Android_6_GAM(Ronnie Tech).apk'>
                            Android_6_GAM
                        </a>
                        <a href="Android_8-9-10_GAM.apk" download='Android_8-9-10_GAM(Ronnie Tech).apk'>
                            Android_8-9-10_GAM
                        </a>
                        <a href="ES File Explorer(RonnieTech).apk" download='Apex Laucher(Ronnie Tech).apk'>
                            ES File Explorer
                        </a>
                        <a href="file manager(RonnieTech)nie Tech).apk" download='File Manager(Ronnie Tech).apk'>
                            File Manager
                        </a>
                        <a href="File Commander Manager(RonnieTech) (1).apk" download='File Commander Manager(Ronnie Tech).apk'>
                            File Commander Manager
                        </a>
                        <a href="Frpbypass (RonnieTech).apk" download='Frpbypass(Ronnie Tech).apk'>
                            Frpbypass
                        </a>
                        <a href="Development Settings(RonnieTech).apk" download='Development Settings(Ronnie Tech).apk'>
                            Development Settings
                        </a>
                        <a href="Setting(RonnieTech).apk" download='Setting(Ronnie Tech).apk'>
                            Setting
                        </a>
                        <a href="Superuser.apk" download='Superuser(Ronnie Tech).apk'>
                            Superuser
                        </a>
                </div>
            </div>
        </div>
    )
}
export default FrpApk;